<template>
  <div class="search-box" style="padding-top:0px;">
    <el-form ref="form" :inline="true" size="mini"  :model="ruleForm" :rules="rules" class="demo-form-inline" style="padding-left:10px;">
      <el-form-item label="系统名称：" prop="name">
        <el-input v-model="ruleForm.name" style="max-width:180px;" clearable ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="submit" v-permission="'0703'">查询</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

export default {
  name: 'search',
  data() {
    return {
      ruleForm: {
        name: ''
      },
      rules: {}
    };
  },
  methods: {
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('getSystemList', this.ruleForm);// emit
        }
        else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
